import axios from '@/util/request'
import store from '@/store'

const baseURL = process.env.VUE_APP_API_URL

export default {
  getProductCustomList: data => axios({ baseURL, url: '/api/product/custom/getProductCustomList', method: 'post', data: { userId: store.state.common.userId, ...data }}), // 获取产品定制列表(前台)
  customProductGetPaymentLogList: params => axios({ baseURL, url: '/api/product/custom/paymentLogList', method: 'get', params }), // 获取收款记录
  customProductUploadFile: data => axios({ baseURL, url: '/api/hbo/uploadFile', method: 'post', data }), // 上传文件阿里云文件服务器
  customProductGetSignValue: params => axios({ baseURL, url: '/api/system/signValue', method: 'get', params }), // 获取阿里云文件服务器上传校验秘钥
  customProductAdd: data => axios({ baseURL, url: '/api/product/open/custom/productCustom', method: 'post', data }), // 创建产品定制(前台)
  customProductProductCustomDetail: id => axios({ baseURL, url: `/api/product/custom/productCustomDetail/${id}`, method: 'get' }), // 获取产品定制详情(前后台)
  customProductEdit: data => axios({ baseURL, url: `/api/product/custom/productCustom`, method: 'put', data }), // 编辑产品定制(前台)
  customProductTransaction: data => axios({ baseURL, url: `/api/payment/transaction`, method: 'post', data }), // 创建交易单
  customProductCustomStatus: data => axios({ baseURL, url: `/api/product/custom/customStatus`, method: 'put', data }) // 更新定制状态(前后台)
}
